module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sub-nav-container"
    }
  }, [_c('nav', {
    attrs: {
      "id": "sub-nav"
    }
  }, [_c('div', {
    staticClass: "container"
  }, _vm._l((_vm.links), function(link) {
    return _c('router-link', {
      class: [{
        selected: link.selected
      }, link.style],
      attrs: {
        "to": link.to,
        "title": link.text
      }
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v(_vm._s(link.text))]), _vm._v(" "), (_vm.isLoggedIn && link.showBadge && !link.selected) ? _c('span', {
      staticClass: "badge"
    }, [_c('i', {
      staticClass: "fas fa-circle"
    })]) : _vm._e()])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d36e0a04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layouts/SubNav.vue
// module id = 918
// module chunks = 2